import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Heart, Shield, Users, FileText, FileCheck, Home } from 'lucide-react';
import { services } from '../data/content';

const Services = () => {
  const iconMap = {
    heart: Heart,
    shield: Shield,
    users: Users,
    'file-text': FileText,
    'file-check': FileCheck,
    home: Home
  };

  return (
    <div className="min-h-screen bg-white pt-32 pb-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Hero Section */}
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold mb-6" style={{ color: '#5E7F8A' }}>
            Our Services
          </h1>
          <p className="text-xl max-w-3xl mx-auto mb-8" style={{ color: '#5E7F8A' }}>
            We help Los Angeles families navigate divorce, separation, and co‑parenting disputes through a structured mediation process.
          </p>
          <div className="w-24 h-1 mx-auto" style={{ backgroundColor: '#9BB2A2' }}></div>
        </div>

        {/* Service Description */}
        <div className="mb-16 max-w-4xl mx-auto">
          <div className="rounded-lg p-10 text-white text-center" style={{ backgroundColor: '#5E7F8A' }}>
            <p className="text-lg leading-relaxed">
              In a series of joint sessions—held remotely or in‑person—we guide you through parenting schedules, support, and property division, then translate your agreements into clear written terms you can file with the court.
            </p>
          </div>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {services.map((service) => {
            const Icon = iconMap[service.icon] || Heart;

            return (
              <Card key={service.id} className="border-0 shadow-md hover:shadow-xl transition-all">
                <CardContent className="p-8">
                  <div 
                    className="w-16 h-16 rounded-full flex items-center justify-center mb-6"
                    style={{ backgroundColor: '#9BB2A2' }}
                  >
                    <Icon size={28} className="text-white" />
                  </div>
                  <h3 className="text-xl font-semibold mb-4" style={{ color: '#5E7F8A' }}>
                    {service.title}
                  </h3>
                  <p className="text-base leading-relaxed" style={{ color: '#5E7F8A' }}>
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Image Section */}
        <div className="mb-16">
          <img 
            src="https://images.unsplash.com/photo-1511632765486-a01980e01a18" 
            alt="Family support"
            className="w-full h-96 object-cover rounded-lg shadow-lg"
          />
        </div>

        {/* Additional Info */}
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-6" style={{ color: '#5E7F8A' }}>
            Virtual and In-Person Options Available
          </h2>
          <p className="text-lg leading-relaxed mb-8" style={{ color: '#5E7F8A' }}>
            We offer both virtual and in-person mediation sessions to accommodate your needs and preferences. Virtual sessions provide flexibility and convenience, while in-person meetings offer a traditional setting when preferred.
          </p>
          <div className="h-1 w-full max-w-md mx-auto" style={{ backgroundColor: '#9BB2A2' }}></div>
        </div>
      </div>
    </div>
  );
};

export default Services;
